// import { useEffect, useState } from "react";
// import axios from "axios";
// import { apiurl } from "../config/config";
// import { toast } from "react-toastify";

// const ManagerAssignCard = ({ application, applicationObjId, onStatusChange, fetchAttendance }) => {
//   const [showReassign, setShowReassign] = useState(false);
//   const [managerOptions, setManagerOptions] = useState([]);
//   const [selectedManager, setSelectedManager] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");

//   console.log("selectedManager",selectedManager);

//   const handleAssignManager = async () => {
//     try {
//       await axios.post(`${apiurl}/api/application/add-manager`, {
//         applicationObjIds: [`${applicationObjId}`],
//         reportingManagerName: selectedManager.reportingManagerName,
//         reportingManagerObjId: reportingManagerObjId,
//         reportingManagerId: reportingManagerId,
//       });

//       toast.success("Manager assigned successfully");
//       onStatusChange && onStatusChange();
//       fetchAttendance && fetchAttendance();
//     } catch (err) {
//       console.error("Error assigning manager:", err);
//       alert("Failed to assign manager.");
//     }
//   };

//   const searchManagers = async (query) => {
//     try {
//       const res = await axios.post(
//         `${apiurl}/api/employee/search`, 
//         {}, // empty body
//         {
//           params: {
//             page: 1,
//             limit: 10,
//             search: query,
//             designation: "assistant-manager,team-leader",
//           },
//         }
//       );
//       setManagerOptions(res.data.users || []);
//     } catch (err) {
//       console.error("Error fetching managers:", err);
//     }
//   };
  

//   useEffect(() => {
//     if (searchTerm.length >= 2) {
//       const delayDebounce = setTimeout(() => {
//         searchManagers(searchTerm);
//       }, 400);
//       return () => clearTimeout(delayDebounce);
//     }
//   }, [searchTerm]);

//   return (
//     <div className="border  bg-white shadow w-full rounded-lg p-4 mt-6">
//       <h3 className="text-lg font-semibold mb-2">Assign Manager</h3>

//       {application?.reportingManagerName && !showReassign ? (
//         <>
//           <p className="text-sm text-gray-700">
//             Assigned Manager:{" "}
//             <span className="font-semibold text-blue-600">
//               {application.reportingManagerName}
//             </span>
//           </p>
//           <button
//             className="mt-2 text-sm text-indigo-600 underline"
//             onClick={() => setShowReassign(true)}
//           >
//             Reassign Manager
//           </button>
//         </>
//       ) : (
//         <>
//           <input
//             type="text"
//             placeholder="Search Manager by name, ID..."
//             className="border p-2 w-full mb-2 rounded"
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />
//           {managerOptions.length > 0 && (
//             <ul className="max-h-40 overflow-y-auto border rounded mb-2">
//               {managerOptions.map((mgr) => (
//                 <li
//                   key={mgr._id}
//                   className="p-2 hover:bg-gray-100 cursor-pointer"
//                   onClick={() => {
//                     setSelectedManager(
//                       mgr.personalDetails?.firstName + " " + mgr.personalDetails?.lastName || mgr.employeeCode
//                     );
//                     setSearchTerm(
//                         mgr.personalDetails?.firstName + " " + mgr.personalDetails?.lastName  || mgr.employeeCode
//                     );
//                     setManagerOptions([]);
//                   }}
//                 >
//                   { mgr.personalDetails?.firstName + " " + mgr.personalDetails?.lastName } ({mgr.employeeCode})
//                 </li>
//               ))}
//             </ul>
//           )}
//           <button
//             className="bg-blue-500 text-white px-4 py-2 rounded max-w-fit"
//             onClick={handleAssignManager}
//             disabled={!selectedManager}
//           >
//             {application?.reportingManagerName ? "Reassign" : "Assign"} Manager
//           </button>
//         </>
//       )}
//     </div>
//   );
// };

// export default ManagerAssignCard;

import { useEffect, useState } from "react";
import axios from "axios";
import { apiurl } from "../config/config";
import { toast } from "react-toastify";

const ManagerAssignCard = ({ application, applicationObjId, onStatusChange, fetchAttendance }) => {
  const [showReassign, setShowReassign] = useState(false);
  const [managerOptions, setManagerOptions] = useState([]);
  const [selectedManager, setSelectedManager] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const handleAssignManager = async () => {
    if (!selectedManager) return;

    try {
      await axios.post(`${apiurl}/api/application/add-manager`, {
        applicationObjIds: [applicationObjId],
        reportingManagerName: selectedManager.managerName,
        reportingManagerObjId: selectedManager.managerObjId,
        reportingManagerId: selectedManager.managerEmployeeId,
      });

      toast.success("Manager assigned successfully");
      onStatusChange && onStatusChange();
      fetchAttendance && fetchAttendance();
    } catch (err) {
      console.error("Error assigning manager:", err);
      alert("Failed to assign manager.");
    }
  };

  console.log("selectedManager", selectedManager);

  const searchManagers = async (query) => {
    try {
      const res = await axios.post(
        `${apiurl}/api/employee/search`,
        {}, // empty body
        {
          params: {
            page: 1,
            limit: 10,
            search: query,
            designation: "assistant-manager,team-leader",
          },
        }
      );
      setManagerOptions(res.data.users || []);
    } catch (err) {
      console.error("Error fetching managers:", err);
    }
  };

  useEffect(() => {
    if (searchTerm.length >= 2) {
      const delayDebounce = setTimeout(() => {
        searchManagers(searchTerm);
      }, 400);
      return () => clearTimeout(delayDebounce);
    }
  }, [searchTerm]);

  return (
    <div className="border bg-white shadow w-full rounded-lg p-4 mt-6">
      <h3 className="text-lg font-semibold mb-2">Assign Manager</h3>

      {application?.reportingManagerName && !showReassign ? (
        <>
          <p className="text-sm text-gray-700">
            Assigned Manager:{" "}
            <span className="font-semibold text-blue-600">
              {application.reportingManagerName}
            </span>
          </p>
          <button
            className="mt-2 text-sm text-indigo-600 underline"
            onClick={() => setShowReassign(true)}
          >
            Reassign Manager
          </button>
        </>
      ) : (
        <>
          <input
            type="text"
            placeholder="Search Manager by name, ID..."
            className="border p-2 w-full mb-2 rounded"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {managerOptions.length > 0 && (
            <ul className="max-h-40 overflow-y-auto border rounded mb-2">
              {managerOptions.map((mgr) => {
                const fullName = `${mgr.personalDetails?.firstName || ""} ${mgr.personalDetails?.lastName || ""}`.trim();
                return (
                  <li
                    key={mgr._id}
                    className="p-2 hover:bg-gray-100 cursor-pointer"
                    onClick={() => {
                      setSelectedManager({
                        managerObjId: mgr._id,
                        managerName: mgr.personalDetails?.firstName + " " + mgr.personalDetails?.lastName,
                        managerEmployeeId: mgr.employeeId,
                      });
                      setSearchTerm(`${fullName} (${mgr.employeeCode})`);
                      setManagerOptions([]);
                    }}
                  >
                    {fullName} ({mgr.employeeCode})
                  </li>
                );
              })}
            </ul>
          )}
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded max-w-fit"
            onClick={handleAssignManager}
            disabled={!selectedManager}
          >
            {application?.reportingManagerName ? "Reassign" : "Assign"} Manager
          </button>
        </>
      )}
    </div>
  );
};

export default ManagerAssignCard;
